/* ⚠️ GENERATED from app/services/textLang.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   🌐 textLang.ts — "is this post in another language?", cheaply, on the device.

   A "See translation" link under every post would be noise; under none, the
   feature does not exist. This answers well enough to decide whether to OFFER
   one: the script first (Arabic, Cyrillic, Han, Kana, Devanagari, Hangul…),
   then — for Latin text — the commonest little words of the languages the app
   speaks. Unsure is null, and null offers nothing. The translation itself is the
   server's (translateRoutes.js), cached per post, language and wording.
   ═══════════════════════════════════════════════════════════════════════════ */

const STOP = {
  en: ['the', 'and', 'is', 'are', 'you', 'this', 'that', 'with', 'for', 'have', 'was', 'what', 'my', 'it', 'not', 'to', 'of', 'in', 'on', 'we'],
  es: ['el', 'la', 'los', 'las', 'que', 'es', 'y', 'en', 'un', 'una', 'por', 'para', 'con', 'no', 'muy', 'pero', 'como', 'del', 'mi', 'está'],
  fr: ['le', 'la', 'les', 'des', 'est', 'et', 'un', 'une', 'pour', 'avec', 'pas', 'que', 'qui', 'dans', 'sur', 'je', 'vous', 'nous', 'très', 'cest'],
  de: ['der', 'die', 'das', 'und', 'ist', 'nicht', 'ich', 'mit', 'ein', 'eine', 'auf', 'für', 'sie', 'wir', 'auch', 'den', 'dem', 'zu', 'sehr', 'heute'],
  pt: ['o', 'os', 'as', 'que', 'é', 'e', 'um', 'uma', 'para', 'com', 'não', 'muito', 'mas', 'como', 'do', 'da', 'meu', 'minha', 'você', 'está']
};

/** The language a piece of text is most likely in, or null when it cannot tell. */
export function guessLang(text) {
  const s = String(text || '').replace(/https?:\/\/\S+/g, ' ').replace(/[#@][\w؀-ۿ]+/g, ' ').trim();
  if (s.length < 4) return null;
  const count = re => (s.match(re) || []).length;
  /* explicit ranges, not \p{L}: Unicode property escapes are not on every JS engine the app runs on */
  const letters = count(/[A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u0900-\u097F\u3040-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]/g);
  if (!letters) return null;
  const share = n => n / letters;
  if (share(count(/[؀-ۿݐ-ݿ]/g)) > 0.4) return 'ar';
  if (share(count(/[Ѐ-ӿ]/g)) > 0.4) return 'ru';
  if (share(count(/[ऀ-ॿ]/g)) > 0.4) return 'hi';
  if (share(count(/[぀-ヿ]/g)) > 0.15) return 'ja';
  if (share(count(/[一-鿿]/g)) > 0.4) return 'zh';
  if (share(count(/[가-힯]/g)) > 0.4) return 'ko';
  if (share(count(/[a-zA-ZÀ-ɏ]/g)) < 0.6) return null;
  const words = s.toLowerCase().replace(/[’']/g, '').split(/[^a-z\u00C0-\u024F]+/).filter(Boolean);
  if (words.length < 3) return null;
  let best = null;
  let bestN = 0;
  let second = 0;
  for (const [lang, list] of Object.entries(STOP)) {
    const set = new Set(list);
    const n = words.reduce((a, w) => a + (set.has(w) ? 1 : 0), 0);
    if (n > bestN) {
      second = bestN;
      bestN = n;
      best = lang;
    } else if (n > second) second = n;
  }
  /* a clear winner, on more than one little word */
  if (bestN >= 2 && bestN > second) return best;
  return null;
}

/** Offer "See translation"? Only when the text is clearly in another language than the reader's. */
export function offersTranslation(text, readerLang) {
  const g = guessLang(text);
  const me = String(readerLang || 'en').toLowerCase().split('-')[0];
  return !!g && g !== me;
}

/** A short, stable fingerprint of the words — a translation is cached against it. */
export function textKey(text) {
  const s = String(text || '');
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) h = (h << 5) + h + s.charCodeAt(i) >>> 0;
  return h.toString(36);
}
